import { useContext } from 'react';
import { GeneralResultsChartsDataContext } from '../contexts/GeneralResultsChartsDataContext';

export const useGeneralResultsChartsDataContext = () => {
    return useContext(GeneralResultsChartsDataContext);
};
